import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Проверяем, является ли ошибка 401 Unauthorized
        if (error.status === 401) {
          console.log('401 Unauthorized error detected, redirecting to login');
          
          // Очищаем данные аутентификации
          this.authService.logout();
          
          // Перенаправляем на страницу логина
          this.router.navigate(['/auth/login']);
          
          // Возвращаем ошибку, чтобы компонент мог обработать её
          return throwError(() => error);
        }
        
        // Для всех остальных ошибок просто пробрасываем их дальше
        return throwError(() => error);
      })
    );
  }
}
